export const FETCH_MEDICLAIM_DETAILS_REQUEST = "FETCH_MEDICLAIM_DETAILS_REQUEST";
export const FETCH_MEDICLAIM_DETAILS_SUCCESS = "FETCH_MEDICLAIM_DETAILS_SUCCESS";
export const FETCH_MEDICLAIM_DETAILS_FAILURE = "FETCH_MEDICLAIM_DETAILS_FAILURE";
